/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2022] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

 import _ from 'lodash';
 import Backbone from 'backbone';
 import { View } from 'backbone.marionette';
 import Syphon from 'backbone.syphon';
 import Ladda from 'ladda';
 import Radio from 'backbone.radio';

 import showErrorMessage from '@/util/showErrorMessage';

 import OrderDevicesView from '../../../order/views/OrderDevicesView/OrderDevicesView';
 import GetLatestOrderLineItemVersionByFormTypeID from '../../../order/services/GetLatestOrderLineItemVersionByFormTypeID'

 import tmplEditOrderFormView from './EditOrderFormView.hbs';
 
 const EditOrderFormView = View.extend({
    template: tmplEditOrderFormView,

    className: 'edit-order-form-page container-fluid',
 
    ui: {
        orderForm: '.order-form-container',
        selectBtn: '.btn-select'
    },
    
    regions: {
        orderForm: '@ui.orderForm',
    },
    
    events: {
        'click @ui.selectBtn': 'onOrderTypeSelect',
    },

    childViewEvents: {
        'save:lineItem': 'onSave'
    },
    
    initialize() {
        const orderFormTypes = this.model.get('orderFormTypes');
        const displayOrderFormTypes = _.filter(orderFormTypes, (type) => {
            const editableTypes = ['13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26'];
            return type.isDisplayed === '1' && _.includes(editableTypes, type.id);
        }); 
        this.model.set('displayOrderFormTypes', displayOrderFormTypes);
    },

    async onOrderTypeSelect(e) {
        e.preventDefault();

        const spinner = Ladda.create(this.ui.selectBtn[0]);
        spinner.start();

        try {
            const formData = Syphon.serialize(this);
            const lineItems = await GetLatestOrderLineItemVersionByFormTypeID(formData.orderFormTypeID);
            const orderDetails = { 
                orderTypeId: formData.orderFormTypeID, 
                isReadOnly: 0, 
                isAdminEdit: true 
            };
            this.orderDevicesView = new OrderDevicesView({
                model: new Backbone.Model({ orderDetails, lineItems })
              });
            this.showChildView('orderForm', this.orderDevicesView)
            spinner.stop();
            Radio.channel('sideNavSectionView').trigger('toggle:saveBtn', true);
        } catch (err) {
            spinner.stop();
            Radio.channel('sideNavSectionView').trigger('toggle:saveBtn', false);
        }
    },

    toggleForm(state) {
        this.$el.find(':input').prop('disabled', !state);
    },

    onSave(e) {
        e.preventDefault();
        const formData = Syphon.serialize(this);

        this.getChildView('orderForm') ? this.getChildView('orderForm').onSave(formData) : this.showNoFormSelectedError();
        this.render();
    },

    showNoFormSelectedError() {
        showErrorMessage({
            errorCode: 'saveError',
            errorTitle: 'No Order Form Type Selected',
            errorMessage:
                'No order form type was selected. Select an order form type to edit and save the form.'
        });
    }
 });
 
 export default EditOrderFormView;
 